import noodleMediaClient, { type ApiDefinition } from '@/tsClient/servers/noodleMedia';

type THIS_API = ApiDefinition['/branding-logo']['POST'];
type Input = THIS_API['body'];
type Output = THIS_API['response'];

const handleUploadLogoAsset = async (formData: Input): Promise<Output> => {
  const data = await noodleMediaClient.post('/branding-logo', formData);
  return data.data;
};

export default handleUploadLogoAsset;
